import React, { ReactNode } from 'react';
import { Avatar, LinkStyled, TailwindSpinner } from '@components/common';
import { useTranslation } from 'next-i18next';
import { VideoCameraIcon } from '@heroicons/react/24/solid';

interface JobBasedInterviewEndScreenProps {
  job?: ApiSchema<'JobItem'>;
  startInterviewAction?: ReactNode;
  skipAction?: ReactNode;
  isLoading?: boolean;
}

const JobBasedInterviewEndScreen = (props: JobBasedInterviewEndScreenProps) => {
  const {
    job, startInterviewAction, skipAction, isLoading,
  } = props;
  const { t } = useTranslation('common');


  if (isLoading) {
    return (
      <div className="flex w-full max-w-sm items-center justify-center">
        <TailwindSpinner />
      </div>
    );
  }

  if (!job) return null;

  return (
    <>
      <p className="mb-4">{t('job.video.interview.next.interview.label')}</p>
      <div className="mb-4 grid max-w-sm grid-cols-10 gap-4 rounded bg-surface-50 p-4">
        <div className="col-span-7 gap-1">
          <h3 className="font-bold">{job.title}</h3>
          <p>{job.companyName}</p>
        </div>
        <div className="relative col-span-3 flex h-15 items-center justify-center">
          <Avatar
            imgPath={job.companyLogo}
            imgFolder="employer_logo"
            extractImageName
            name={job.companyName}
            size="md"
            aspectRatio="square-fit"
            rounding="none"
            id={(job.companyName || job.slug || '').charCodeAt(0)}
          />
        </div>
      </div>
      <div className="flex w-full max-w-sm items-center gap-4">
        {/* If there is no skip action use a placeholder div to keep layout consistent */}
        {skipAction || <div className="flex-1" />}
        {startInterviewAction || (
          <LinkStyled
            styling="solid"
            color="secondary"
            rounding="full"
            href={`/job/${job.slug}/ai-interview`}
            className="flex-1 gap-2"
          >
            <VideoCameraIcon className="size-5" />
            {t('ai.interview.start')}
          </LinkStyled>
        )}
      </div>
    </>
  );
};
export default JobBasedInterviewEndScreen;
